import router from '@/router'
import { getStorage } from './index';
import { Toast } from 'vant';
import { showToast } from '@/utils'
import CryptoJS from 'crypto-js';

if (window?.Android) {
    // 点击返回键
    let newDate = 0
    const backPage = () => {
        if (+new Date() - newDate < 1000) {
            Toast.clear();
            window?.Android?.goPhoneHome()
        } else {
            if (router?.currentRoute?.meta?.index > 0) {
                router.go(-1)
            } else {
                newDate = +new Date()
                showToast('Press again to push out');
            }
        }
    }

    /**
     * on show
     */
    const onShow = () => {
        console.log(`---------------onShow----------------`)
        console.log('show 1121212121212');
    }

    /**
     * on hide
     */
    const onHide = () => {
        console.log(`---------------onHide----------------`)
        const storageMap = {}
        const keys = Object.keys(localStorage);
        keys.forEach((key) => {
            const value = getStorage(key);
            try {
                storageMap[key] = JSON.parse(value)
            } catch (error) {
                storageMap[key] = value
            }
        });
        window?.Android?.saveData('storageMap', JSON.stringify(storageMap))
    }

    /**
     * 失败提示
     */
    const showFailDialog = (message) => {
        Toast.fail(message)
    }

    /**
     * 成功提示
     */
    const showSuccessDialog = (message) => {
        Toast.success(message)
    }

    /**
     * 加载中
     */
    const showLoadingDialog = () => {
        Toast.loading({
            position: 'middle',
            forbidClick: true,
            overlay: false,
            duration: 0,
            iconSize: 48
        });
    }

    /**
     * 关闭提示
     */
    const closeLoading = () => {
        Toast.clear()
    }





    window.backPage = backPage;
    window.onShow = onShow;
    window.onHide = onHide;
    window.showFailDialog = showFailDialog;
    window.showSuccessDialog = showSuccessDialog;
    window.showLoadingDialog = showLoadingDialog;
    window.closeLoading = closeLoading;
    window.requestPermissionCallback = () => { }
}


window.getAesString = function(data, key) {//加密
    let iv = "0102030405060708";
    let keyArr = CryptoJS.enc.Latin1.parse(key);
    let ivArr = CryptoJS.enc.Latin1.parse(iv);
    let srcs = CryptoJS.enc.Utf8.parse(data);

    let encrypted = CryptoJS.AES.encrypt(srcs, keyArr, {
        iv : ivArr,
        mode : CryptoJS.mode.CBC,
        padding : CryptoJS.pad.Pkcs7,
        formatter: CryptoJS.enc.Base64
    });
    return encrypted.toString();
}
window.decodeAesString = function(data, key) {//加密
    let iv = "0102030405060708";
    let keyArr = CryptoJS.enc.Latin1.parse(key);
    let ivArr = CryptoJS.enc.Latin1.parse(iv);

    let decoded = CryptoJS.AES.decrypt(data, keyArr, {
        iv : ivArr,
        mode : CryptoJS.mode.CBC,
        padding : CryptoJS.pad.Pkcs7
    });
    return decoded.toString(CryptoJS.enc.Utf8);
}

window.getSignString = function(data) {//加密
    let srcs = CryptoJS.enc.Utf8.parse(data);
    let encrypted = CryptoJS.MD5(srcs);
    return encrypted.toString().toUpperCase();
}